import { DateTime } from 'luxon'

export type SeDateString = string // i.e '2019-07-23'
export type SeDateTimeString = string // i.e '2019-07-23T20:07:37.000Z'
export type SeTimeZoneName = string // i.e. 'America/Chicago'
export type SeDateTimeFormatModifier = (str: string) => string
export type SeDateTimeChunkFinder = (format: string) => SeDateTimeChunk[]

export interface SeDateTimeFormatCondition {
  [key: string]: (luxon?: DateTime) => boolean
}

export interface SeDateTimeChunk {
  luxon: DateTime
  format: string
}

export interface SeDateTimeOptions {
  timeTbd?: boolean
  allDay?: boolean
  zone?: SeTimeZoneName
}

export interface SeDateTimeConfig {
  formats: SeDateTimeFormats
  deviceZone: SeTimeZoneName
}

export interface SeDateTimeRangeValue {
  starts_at: string
  ends_at: string
}

export enum SeDateTimeModifier {
  AllDay = 'all-day',
  Range = 'range',
  SameDay = 'same-day',
  TimeTbd = 'tbd',
}

export enum SeDateTimeFormat {

  // INDETERMINATE
  TimeTbd = 'time-tbd',
  AllDay = 'all-day',

  // SEPARATORS
  At = 'at',
  From = 'from',
  Through = 'through',
  To = 'to',

  // CONDITIONALS
  DifferentMeridiem = '<!=meridiem>',
  DifferentDays = '<!=day>',
  DifferentMonths = '<!=month>',
  DifferentYears = '<!=year>',
  NonCurrentYear = '<!~year>',
  NonDeviceZone = '<!~zone>',
  NonZeroMinutes = '<non-zero-minutes>',

  // PARTIALS
  DayOfWeek = 'day-of-week',
  DayOfWeekRange = 'day-of-week-range',
  DayOfMonth = 'day-of-month',
  Year = 'year',
  YearRange = 'year-range',
  Time = 'time',
  TimeRange = 'time-range',
  TimeWithZone = 'time-with-zone',
  Zone = 'zone',

  // MONTH (and year if necessary)
  Month = 'month',
  MonthRange = 'month-range',

  // SHORT DATE
  ShortDate = 'short-date',
  ShortDateRange = 'short-date-range',
  ShortDateRangeSameDay = 'short-date-range-same-day',

  // DATE
  Date = 'date',
  DateRange = 'date-range',
  DateRangeSameDay = 'date-range-same-day',

  // FULL DATE
  FullDate = 'full-date',
  FullDateRange = 'full-date-range',
  FullDateRangeSameDay = 'full-date-range-same-day',

  // SHORT DATE TIME
  ShortDateTime = 'short-date-time',
  ShortDateTimeRange = 'short-date-time-range',
  ShortDateTimeRangeSameDay = 'short-date-time-range-same-day',

  // DATE TIME
  DateTime = 'date-time',
  DateTimeRange = 'date-time-range',
  DateTimeRangeSameDay = 'date-time-range-same-day',

  // FULL DATE TIME
  FullDateTime = 'full-date-time',
  FullDateTimeRange = 'full-date-time-range',
  FullDateTimeRangeSameDay = 'full-date-time-range-same-day',
}

export type SeDateTimeFormats = {
  [key in keyof typeof SeDateTimeFormat]: string
}
